import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGold: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGold"><Path d="M12.001 17.8262L14.0986 12H20.9033L23.4238 19H0.578125L3.09863 12H9.90332L12.001 17.8262Z" fill="currentColor"/><Path d="M17.9238 11H6.07812L8.59863 4H15.4033L17.9238 11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGold;
